import { render, staticRenderFns } from "./ShopSettings.vue?vue&type=template&id=36296dd6"
import script from "./ShopSettings.vue?vue&type=script&lang=js"
export * from "./ShopSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports